import { View } from "react-native-ui-lib";
import { Image } from "react-native";
import { useThemeProvider } from "@towersystems/roam-common-native";
export interface LogoProps {}

export const Logo = ({}: LogoProps) => {
  const { scheme } = useThemeProvider();

  return (
    <View>
      <Image
        style={{ width: 65, height: 40 }}
        source={
          scheme == "dark"
            ? require("../../../assets/images/logo_white_xs.png")
            : require("../../../assets/images/logo_xs.png")
        }
      />
    </View>
  );
};
